module.exports = __webpack_public_path__ + "img/grand-temple-abu-simbel-1024x678.3ed2b130.jpeg";